import { useMedias } from '@divlab/divanui';
import { memo } from 'react';

import Img from '@UI/Img';
import styles from './AdviseAssortmentBanner.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { IBanner } from '@Pages/PageShowroom/typings';

export interface AdviseAssortmentBannerProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  banner?: IBanner;
}

const AdviseAssortmentBanner: FC<AdviseAssortmentBannerProps> = (props) => {
  const { banner, ...restProps } = props;
  const { isMobile } = useMedias();

  const imageSrc = isMobile ? banner.images.src_360 : banner.images.src;
  return (
    <div className={styles.assortment} {...restProps}>
      <Img className={styles.imageContainer} cnImage={styles.image} src={imageSrc} />
      <div className={styles.textBlock}>
        <h3 className={styles.title}>{banner.title}</h3>
        <p className={styles.text}>{banner.text}</p>
      </div>
    </div>
  );
};

export default memo(AdviseAssortmentBanner);
